import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=8e5d959e&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"
import style0 from "./Footer.vue?vue&type=style&index=0&id=8e5d959e&prod&lang=sass&"
import style1 from "./Footer.vue?vue&type=style&index=1&id=8e5d959e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e5d959e",
  null
  
)

export default component.exports